var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('qriously',{attrs:{"value":_vm.value,"size":_vm.size}}),(_vm.showText)?_c('span',[_vm._v(_vm._s(_vm.value))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }